import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles } from "lucide-react";

/* SCHERMATA D'INGRESSO — i telefoni vietano l'audio automatico,
   quindi la sorpresa si apre con un tocco: la musica parte e il
   sipario si alza sulla storia. */
export const IntroGate = ({ onStart }) => {
  const [open, setOpen] = useState(false);

  /* finché il sipario è calato la pagina non scorre */
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
      window.__lenis?.start();
      return;
    }
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    /* lenis nasce in App dopo questo effetto: fermalo appena è pronto */
    const ferma = setInterval(() => {
      if (window.__lenis) {
        window.__lenis.stop();
        clearInterval(ferma);
      }
    }, 100);
    return () => clearInterval(ferma);
  }, [open]);

  const start = () => {
    /* il brano potrebbe non essere ancora pronto: riprova per un attimo */
    const prova = (tentativi) => {
      const a = document.getElementById("bg-music");
      if (a) {
        a.muted = false;
        a.currentTime = 0;
        a.play().catch(() => {});
      } else if (tentativi > 0) {
        setTimeout(() => prova(tentativi - 1), 250);
      }
    };
    prova(12);
    setOpen(true);
    onStart?.();
  };

  return (
    <AnimatePresence>
      {!open && (
        <motion.div
          className="intro-gate"
          data-testid="intro-gate"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 1.2, ease: "easeInOut" } }}
        >
          <div className="intro-gate-glow" aria-hidden="true" />
          <motion.span
            className="intro-star"
            aria-hidden="true"
            initial={{ opacity: 0, scale: 0.4 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.3, duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          >
            ✦
          </motion.span>
          <motion.p
            className="intro-eyebrow"
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 1, ease: [0.22, 1, 0.36, 1] }}
          >
            c'è una cosa che voglio farti vedere
          </motion.p>
          <motion.button
            className="intro-start"
            data-testid="intro-start-btn"
            onClick={start}
            aria-label="Tocca per iniziare la sorpresa con la musica"
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.1, duration: 1, ease: [0.22, 1, 0.36, 1] }}
            whileTap={{ scale: 0.94 }}
          >
            <span className="intro-start-ring" aria-hidden="true" />
            <span className="intro-start-ring intro-start-ring--late" aria-hidden="true" />
            <Sparkles size={17} />
            Tocca per iniziare
          </motion.button>
          <motion.p
            className="intro-note"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.7, duration: 1.2 }}
          >
            alza il volume: la sorpresa ha una colonna sonora
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
